import { SMS_TEMPLATES_LIST_LOADING, SMS_TEMPLATES_LIST_SUCCESS, SMS_TEMPLATES_LIST_FAILED, VOICE_TEMPLATES_LIST_SUCCESS, EMAIL_TEMPLATES_LIST_SUCCESS } from '../actions/verify.action';

import { IVerifyTemplates, SmsTemplatesList } from '../models/smsTemplates.interface';

const initialState: SmsTemplatesList = {
    smsLoading: true,
    smsError: false,
    smsMessage: "",
    voiceData: [],
    smsData: [],
    emailData: [],
    smsTotal: 0
}

const SmsTemplatesListReducer = (state: SmsTemplatesList = initialState, action: any): SmsTemplatesList => {
    switch (action.type) {
        case SMS_TEMPLATES_LIST_LOADING:
            return {
                ...state,
                smsLoading: true,
                smsError: false
            }
        case SMS_TEMPLATES_LIST_SUCCESS:
            const newData = action.payload.res.map((item: IVerifyTemplates) => {
                return { id: item.id, name: item.name, created_at: item.created_at, created_by: item.created_by, body: item.body,meta_value:item.meta_value, user_details:item.user_details }
            });
            return {
                ...state,
                smsLoading: false,
                smsError: false,
                smsMessage: "",
                smsData: newData
            }
        case VOICE_TEMPLATES_LIST_SUCCESS:
            const newVData = action.payload.res.map((item: IVerifyTemplates) => {
                return { id: item.id, name: item.name, created_at: item.created_at, created_by: item.created_by, body: item.body, meta_value:item.meta_value, user_details:item.user_details }
            });
            return {
                ...state,
                smsLoading: false,
                smsError: false,
                smsMessage: "",
                voiceData: newVData
            }
        case EMAIL_TEMPLATES_LIST_SUCCESS:
            const newEData = action.payload.res.map((item: IVerifyTemplates) => {
                return { id: item.id, name: item.name, created_at: item.created_at, created_by: item.created_by, body: item.body,meta_value:item.meta_value, user_details:item.user_details }
            });
            return {
                ...state,
                smsLoading: false,
                smsError: false,
                smsMessage: "",
                emailData: newEData
            }
        case SMS_TEMPLATES_LIST_FAILED:
            return {
                ...state,
                smsLoading: false,
                smsError: true,
                smsMessage: action.payload.error.message || ""
            }
        default:
            return state;
    }
}

export default SmsTemplatesListReducer;